import type { RequiredGeneric } from '@pba/react-utils';
import { useGetUserFullNameWithFallback } from '@pba/react-utils';
import { Fragment } from 'react';
import { Button, Divider, EntitySnippet, Flex, Form, Icon, Text } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependencies
import { useGetNodeUserAvatar } from 'features/users/hooks';
import type { ExtendedChatGroupAddMembersFormValues } from '../chat-group-add-members-select';

const ChatGroupAddMembersSelectedList = <T extends ExtendedChatGroupAddMembersFormValues = never>(
  _: RequiredGeneric<T>,
) => {
  const form = Form.useFormInstance<ExtendedChatGroupAddMembersFormValues>();
  const users = Form.useWatch<ExtendedChatGroupAddMembersFormValues['users']>('users') ?? [];
  const getAvatarUrl = useGetNodeUserAvatar();
  const getUserFullNameWithFallback = useGetUserFullNameWithFallback();

  const handleRemoveUser = (userId: string) => {
    form.setFieldValue(
      'users',
      users.filter((selectedUser) => selectedUser.id !== userId),
    );
  };

  if (users.length === 0) {
    return null;
  }

  return (
    <Flex vertical>
      <Text size="small" type="secondary">
        Selected
      </Text>
      <Flex className="chat-group-add-members-selected-list" vertical>
        {users.map((user, index) => (
          <Fragment key={user.id}>
            <EntitySnippet
              avatarProps={{ src: getAvatarUrl({ userId: user.id }) }}
              descriptionProps={{ children: user.email }}
              extra={
                <Button
                  icon={<Icon color="error" icon="minus-circle-line" />}
                  onClick={() => {
                    handleRemoveUser(user.id);
                  }}
                  type="link-secondary"
                />
              }
              titleProps={{ children: getUserFullNameWithFallback(user), weight: 'medium' }}
            />
            {index < users.length - 1 ? <Divider className="chat-group-add-members-selected-list__divider" /> : null}
          </Fragment>
        ))}
      </Flex>
    </Flex>
  );
};

export default ChatGroupAddMembersSelectedList;
